/** Canonicalize user input; the server additionally validates the country's numbering plan. */
export function normalizeWhatsAppPhoneNumber(input) {
    const trimmed = input.trim();
    if (!/^[+\d\s()./-]+$/u.test(trimmed))
        return null;
    const digits = trimmed.replace(/^(\+49|0049)\s*\(0\)/u, '$1').replace(/[\s()./-]/gu, '');
    const normalized = digits.startsWith('00')
        ? `+${digits.slice(2)}`
        : digits.startsWith('0')
            ? `+49${digits.slice(1)}`
            : digits.startsWith('+')
                ? digits
                : `+${digits}`;
    return /^\+[1-9]\d{7,14}$/u.test(normalized) ? normalized : null;
}
//# sourceMappingURL=whatsapp-phone.js.map